import React, { useState, useEffect } from "react"
import PointerControls from "../../components/Controls"
import DeviceControls from "../../components/DeviceControls"

const Controls = (props) => {
  const {
    supportsOrientation,
    controlsOn,
    init,
    passOverInclination,
  } = props
  // const [devControls, setDevControls] = useState(false)

  return (
    <>
      {!supportsOrientation && <PointerControls />}
      {supportsOrientation && init && (
        <DeviceControls
          passOverInclination={passOverInclination}
          active={controlsOn}
        />
      )}
      {/* {supportsOrientation && init && <OrbitControls />} */}
    </>
  )
}

export default Controls
